import { ViewportType } from 'game-ui-types'
import { ViewportConfigurations } from './types'

// Configuration 3 [6x5 Squаre Reels (Gorgons) / 6x6 Square reels / 7x7 Square reels / 3x3 Square reels]
export const slotConfigC: ViewportConfigurations = {
    [ViewportType.MOBILE_PORTRAIT]: {
        SpinButtonSection: {
            position: { top: '1132px', left: '175px' },
            styles: 'gap-[10px] items-start',
        },
        SpinButtonSectionLeftHand: {
            position: { top: '1132px', left: '175px' },
        },
        SpinButtonGambleSection: {
            position: { top: '1132px', left: '175px' },
            styles: 'gap-[10px] items-start',
        },
        SpinButtonGambleSectionLeftHand: {
            position: { top: '1132px', left: '175px' },
        },
        SpinButton: {
            styles: '',
        },
        StopButton: {
            position: { top: '150px', left: '0' },
            styles: 'bg-black fixed opacity-0 w-full h-[60%] z-[0]',
        },
        BetOptionButton: {
            styles: '',
        },
        BetOptionSection: {
            position: { bottom: '371px' },
            styles: 'left-1/2 transform -translate-x-1/2 bg-[#131313]',
        },
        AutoplayButton: {
            styles: '',
        },
        AutoplaySection: {
            position: { bottom: '225px', left: '-20px' },
            styles: 'absolute bg-[#131313]',
        },
        AutoplaySectionLeftHand: {
            position: { bottom: '225px', left: '-20px' },
        },
        SpeedButton: {
            position: { bottom: '-80px', left: '50%' },
            styles: 'absolute translate-x-[-50%]',
        },
        PlayerInfoWrapperClass: { styles: '' },
        PlayerInfoBalance: {
            position: { bottom: '58px', left: '112px' },
            dimensions: { width: '224px' },
        },
        PlayerInfoBalanceJackpot: {
            position: { bottom: '58px', left: '112px' },
            dimensions: { width: '224px' },
        },
        PlayerInfoBalanceGamble: {
            position: { bottom: '136px', left: '8px' },
            dimensions: { width: '250px' },
            styles: 'ml-0 flex-row',
        },
        PlayerInfoLastWin: {
            dimensions: { minWidth: '371px' },
            position: { bottom: '458px', left: '50%' },
            styles: 'flex-row translate-x-[-50%] justify-center items-baseline',
        },
        PlayerInfoLastWinGamble: {
            position: { bottom: '136px', right: '8px' },
            dimensions: { width: '180px' },
            styles: 'ml-0 flex-row justify-end',
        },
        PlayerInfoWinLabel: {
            styles: 'mr-[8px]',
        },
        PlayerInfoCurrencyLabel: {
            styles: 'ml-[8px]',
        },
        PlayerInfoLastWinMoneyWrapper: {
            styles: 'flex flex-row items-baseline',
        },
        PlayerInfoExternalBetAmount: {
            styles: 'rounded-[100px] bg-black/50',
            position: { bottom: '142px', right: '16px' },
            dimensions: { width: '166px', height: '76px' },
        },
        PlayerInfoAdditionalWinAmount: {
            dimensions: { width: '172px' },
        },
        BetSlider: {
            position: { bottom: '316px' },
        },
        DoubleChanceButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '140px', left: '16px' },
        },
        DoubleChanceButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { top: '4px', right: '0px' },
        },
        BuyBonusButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '140px', right: '16px' },
        },
        BuyBonusButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { bottom: '17px', right: '0px' },
        },
        AmuseBoostButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '145px', right: '16px' },
        },
        AmuseBoostModal: {
            dimensions: { width: '132px', height: '274px' },
            position: { bottom: '320px', right: '22px' },
        },
        PromoWidget: {
            position: { bottom: '145px', left: '16px' },
            dimensions: { width: '132px', height: '168px' },
        },
        Navigation: {
            styles: 'px-[16px] flex justify-between',
            position: { bottom: '56px' },
        },
        NavigationLeftWrapper: {
            styles: '',
        },
        NavigationRightWrapper: {
            styles: 'flex gap-[20px]',
        },
        Compliance: {
            styles: 'px-[8px] flex justify-between text-[14px] leading-[18px]',
        },
        ComplianceColLeft: {
            styles: '',
        },
        ComplianceColCenter: {
            styles: '',
        },
        ComplianceColRight: {
            styles: '',
        },
        CustomResult: {
            position: { top: '202px', left: '5px' },
            styles: 'absolute w-[35px] h-[35px] z-[200]',
        },
        InfoLine: {
            position: { top: '992px' },
            styles: 'absolute h-[36px] w-[810px] flex justify-center items-center text-center translate-x-[-50%] left-[50%] bg-winline-gradient',
        },
        InfoLineJackpot: {
            position: { top: '955px' },
        },
        InfoLineWinLineWrapper: {
            styles: 'w-full flex gap-[16px] justify-center items-center',
        },
        InfoLineWinAmount: {
            styles: 'text-[24px] leading-[24px] text-white flex items-baseline font-bold',
        },
        InfoLineNumber: {
            styles: 'text-[24px] leading-[24px] text-white text-center font-bold',
        },
        InfoLineText: {
            styles: 'text-[30px] leading-[30px] text-white text-center font-bold',
        },
        InfoLineImageWrapper: {
            dimensions: { width: '36px', height: '36px' },
            styles: 'flex gap-[16px] items-center justify-center',
        },
        InfoLineFreespinText: {
            styles: 'text-[30px] leading-[30px] w-[368px] text-white text-center font-bold',
        },
        JackpotHistory: {
            position: { top: '170px' },
            dimensions: { height: '1267px' },
        },
        RemainingSpinsBanner: {
            position: { bottom: '326px' },
        },
    },
    [ViewportType.MOBILE_LANDSCAPE]: {
        SpinButtonSection: {
            dimensions: { width: '200px' },
            position: { bottom: '215px', right: '103px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonSectionLeftHand: {
            position: { bottom: '215px', left: '103px' },
        },
        SpinButtonGambleSection: {
            dimensions: { width: '200px' },
            position: { bottom: '215px', right: '103px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonGambleSectionLeftHand: {
            position: { bottom: '215px', left: '103px' },
        },
        SpinButton: {
            styles: '',
        },
        StopButton: {
            position: { top: '70px', left: '330px' },
            styles: 'bg-black fixed opacity-0 w-[55%] h-[75%] z-[0]',
        },
        BetOptionButton: {
            styles: '',
        },
        BetOptionSection: {
            styles: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#131313]',
        },
        AutoplayButton: {
            styles: '',
        },
        AutoplaySection: {
            position: { top: '0', right: '180px' },
            styles: 'absolute bg-[#131313]',
        },
        AutoplaySectionLeftHand: {
            position: { top: '0', left: '180px' },
        },
        SpeedButton: {
            styles: 'z-[51] mt-[-25px] flex',
        },
        PlayerInfoWrapperClass: { styles: '' },
        PlayerInfoBalance: {
            position: { bottom: '25px', left: '101px' },
            dimensions: { width: '224px' },
        },
        PlayerInfoLastWin: {
            dimensions: { width: '224px' },
            position: { bottom: '25px', right: '95px' },
            styles: 'flex-col',
        },
        PlayerInfoWinLabel: {
            styles: '',
        },
        PlayerInfoCurrencyLabel: {
            styles: '',
        },
        PlayerInfoLastWinMoneyWrapper: {
            styles: 'flex flex-col items-center',
        },
        PlayerInfoExternalBetAmount: {
            styles: 'rounded-[100px] bg-black/50',
            position: { bottom: '209px', right: '10px' },
            dimensions: { width: '166px', height: '76px' },
        },
        PlayerInfoAdditionalWinAmount: {
            dimensions: { width: '172px' },
        },
        BetSlider: {
            position: { bottom: '24px' },
        },
        DoubleChanceButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '128px', left: '36px' },
        },
        DoubleChanceButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { top: '4px', right: '0px' },
        },
        BuyBonusButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '128px', left: '178px' },
        },
        BuyBonusButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { bottom: '17px', left: '0px' },
        },
        AmuseBoostButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '128px', left: '162px' },
        },
        AmuseBoostModal: {
            dimensions: { width: '132px', height: '274px' },
            position: { bottom: '299px', left: '166px' },
        },
        PromoWidget: {
            position: { bottom: '128px', left: '34px' },
            dimensions: { width: '132px', height: '168px' },
        },
        Navigation: {
            styles: 'px-[10px] flex justify-between items-end',
            position: { bottom: '27px' },
        },
        NavigationLeftWrapper: {
            styles: '',
        },
        NavigationRightWrapper: {
            styles: 'w-[162px] h-[172px] flex flex-wrap justify-end content-end gap-y-[20px] gap-x-[10px]',
        },
        Compliance: {
            styles: 'px-[8px] flex justify-between text-[14px] leading-[18px]',
        },
        ComplianceColLeft: {
            styles: 'flex gap-[30px] flex-row-reverse',
        },
        ComplianceColCenter: {
            styles: 'flex gap-[30px]',
        },
        ComplianceColRight: {
            styles: 'flex gap-[30px]',
        },
        CustomResult: {
            position: { top: '176px', left: '5px' },
            styles: 'absolute w-[50px] h-[50px] z-[200]',
        },
        InfoLine: {
            position: { bottom: '129px' },
            styles: 'absolute h-[36px] w-[810px] flex justify-center items-center text-center translate-x-[-50%] left-[50%] bg-winline-gradient',
        },
        InfoLineJackpot: {
            position: { bottom: '87px' },
        },
        InfoLineWinLineWrapper: {
            styles: 'w-full flex gap-[16px] justify-center items-center',
        },
        InfoLineWinAmount: {
            styles: 'text-[24px] leading-[24px] text-white flex items-baseline font-bold',
        },
        InfoLineNumber: {
            styles: 'text-[24px] leading-[24px] text-white text-center font-bold',
        },
        InfoLineText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        InfoLineImageWrapper: {
            dimensions: { width: '36px', height: '36px' },
            styles: 'flex gap-[16px] items-center justify-center',
        },
        InfoLineFreespinText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        JackpotHistory: {
            position: { top: '72px' },
            dimensions: { height: '738px' },
        },
        RemainingSpinsBanner: {
            position: { bottom: '27px' },
        },
    },
    [ViewportType.DESKTOP]: {
        SpinButtonSection: {
            dimensions: { width: '200px' },
            position: { bottom: '314px', right: '170px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonSectionLeftHand: {
            position: { bottom: '314px', left: '170px' },
        },
        SpinButtonGambleSection: {
            dimensions: { width: '200px' },
            position: { bottom: '314px', right: '170px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonGambleSectionLeftHand: {
            position: { bottom: '314px', left: '170px' },
        },
        SpinButton: {
            styles: '',
        },
        StopButton: {
            position: { top: '100px', left: '430px' },
            styles: 'bg-black fixed opacity-0 w-[50%] h-[75%] z-[0]',
        },
        BetOptionButton: {
            styles: '',
        },
        BetOptionSection: {
            styles: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#131313]',
        },
        AutoplayButton: {
            styles: '',
        },
        AutoplaySection: {
            position: { top: '0', right: '180px' },
            styles: 'absolute bg-[#131313]',
        },
        AutoplaySectionLeftHand: {
            position: { top: '0', left: '180px' },
        },
        SpeedButton: {
            styles: 'z-[51] mt-[-25px] flex',
        },
        PlayerInfoWrapperClass: { styles: '' },
        PlayerInfoBalance: {
            position: { bottom: '33px', left: '286px' },
            dimensions: { width: '224px' },
        },
        PlayerInfoLastWin: {
            dimensions: { width: '224px' },
            position: { bottom: '33px', right: '296px' },
            styles: 'flex-col',
        },
        PlayerInfoWinLabel: {
            styles: '',
        },
        PlayerInfoCurrencyLabel: {
            styles: '',
        },
        PlayerInfoLastWinMoneyWrapper: {
            styles: 'flex flex-col items-center',
        },
        PlayerInfoExternalBetAmount: {
            styles: 'rounded-[100px] bg-black/50',
            position: { bottom: '209px', right: '10px' },
            dimensions: { width: '166px', height: '76px' },
        },
        PlayerInfoAdditionalWinAmount: {
            dimensions: { width: '172px' },
        },
        BetSlider: {
            position: { bottom: '30px' },
        },
        BetSliderArrowLeft: {
            position: { top: '4px', left: '-36px' },
        },
        BetSliderArrowRight: {
            position: { top: '4px', right: '-36px' },
        },
        DoubleChanceButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '170px', left: '232px' },
        },
        DoubleChanceButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { top: '4px', right: '0px' },
        },
        BuyBonusButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '170px', left: '232px' },
        },
        BuyBonusButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { bottom: '17px', right: '0px' },
        },
        AmuseBoostButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '170px', left: '215px' },
        },
        AmuseBoostModal: {
            dimensions: { width: '132px', height: '274px' },
            position: { bottom: '345px', left: '223px' },
        },
        PromoWidget: {
            position: { bottom: '170px', left: '88px' },
            dimensions: { width: '132px', height: '168px' },
        },
        Navigation: {
            styles: 'px-[15px] flex justify-between',
            position: { bottom: '34px' },
        },
        NavigationLeftWrapper: {
            styles: 'flex gap-[10px]',
        },
        NavigationRightWrapper: {
            styles: 'flex gap-[10px]',
        },
        Compliance: {
            styles: 'px-[8px] flex justify-between text-[20px] leading-[24px]',
        },
        ComplianceColLeft: {
            styles: 'flex gap-[30px] flex-row-reverse',
        },
        ComplianceColCenter: {
            styles: 'flex gap-[30px]',
        },
        ComplianceColRight: {
            styles: 'flex gap-[30px]',
        },
        CustomResult: {
            position: { top: '233px', left: '5px' },
            styles: 'absolute w-[70px] h-[70px] z-[200]',
        },
        InfoLine: {
            position: { bottom: '132px' },
            styles: 'absolute h-[36px] w-[810px] flex justify-center items-center text-center translate-x-[-50%] left-[50%] bg-winline-gradient',
        },
        InfoLineJackpot: {
            position: { bottom: '97px' },
        },
        InfoLineWinLineWrapper: {
            styles: 'w-full flex gap-[16px] justify-center items-center',
        },
        InfoLineWinAmount: {
            styles: 'text-[24px] leading-[24px] text-white flex items-baseline font-bold',
        },
        InfoLineNumber: {
            styles: 'text-[24px] leading-[24px] text-white text-center font-bold',
        },
        InfoLineText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        InfoLineImageWrapper: {
            dimensions: { width: '36px', height: '36px' },
            styles: 'flex gap-[16px] items-center justify-center',
        },
        InfoLineFreespinText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        JackpotHistory: {
            position: { top: '94px' },
            dimensions: { height: '986px' },
        },
        RemainingSpinsBanner: {
            position: { bottom: '35px' },
        },
    },
}
